<script lang="ts">
	import * as m from '$paraglide/messages';
	import DatasheetDetailBlock from './DatasheetDetailBlock.svelte';

	export let title: string;
	export let text: string;
	let isOverflowed = false;
	let isExpanded = false;
	let textBox: HTMLDivElement;
	let borderBoxSize: ResizeObserverSize[];

	$: updateSize(borderBoxSize);
	function updateSize(_borderBoxSize: ResizeObserverSize[]): void {
		// This function uses borderBoxSize as a parameter for reactivity only.
		isOverflowed = !!(
			textBox?.offsetHeight < textBox?.scrollHeight || textBox?.offsetWidth < textBox?.scrollWidth
		);
	}

	function expandText() {
		isExpanded = true;
	}
</script>

<DatasheetDetailBlock {title}>
	<div class:clamp-lines-7={!isExpanded} bind:this={textBox} bind:borderBoxSize>{text}</div>
	{#if isOverflowed && !isExpanded}
		<button
			type="button"
			on:click={expandText}
			class="text-body border-0 bg-transparent underline p-0 text-md cursor-pointer"
		>
			{m.poi_datasheet__see_more()}
		</button>
	{/if}
</DatasheetDetailBlock>
